<template>
  <!-- 选择学生 -->
  <div class="maskdiv" v-if="!isHideSelectStudent" @click="close">
    <div class="slider" style="padding:0 5px" @click.stop>
      <mt-index-list>
        <strong class="tit">选择学生</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <mt-index-section :index="firstCharList.firstChar" v-for="firstCharList in studentFirstCharList">
             <li class="list-group-item primary">
              <div class="list-group" v-for="student in firstCharList.students">
                <!-- <div @click.stop="student.isChecked = !student.isChecked"> -->
                <div @click.stop="selected(student)">
                  <div class="clearfix" style="padding:10px 15px"><span class="pull-left">{{student.studentName}}</span>
                    <i class="pull-right img-checkbox" v-bind:class="{'checked': student.isChecked}" ></i>
                  </div>
                  <div class="liner"></div>
                </div>
              </div>
            </li>
          </mt-index-section>
        </div>
        <div class="text-center"><a class="button button-rounded button-line" @click.prevent="close">确定</a></div>
      </mt-index-list>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png')
    }
  },
  props: {
    studentFirstCharList: {
      type: Array,
      required: true
    },
    isHideSelectStudent: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    selected: function (student) {
      this.$emit('selected', student)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>




// WEBPACK FOOTER //
// dialogStudents.vue?2a8c4edc